import classNames from "classnames";
import React, { useEffect, useMemo, useState } from "react";
import { ICategory } from "../../model/base";
import styles from "./bannerHeader.module.scss";
import Link from "next/link";
import router, { useRouter } from "next/router";
import { useWindowSize } from "../../util/functionGlobal";


interface BannerHeaderBreadcrumbArticleProps {
  breadcrumb: ICategory[];
  cateMapping: any[];
  title: string;
  modDate: string;
  view?: string;
  img: string;
  createdBy?: string;
  article;
}

export function BannerHeaderBreadcrumbArticle(props: BannerHeaderBreadcrumbArticleProps) {
  const { breadcrumb, title, modDate, view, img, createdBy, cateMapping, article } = props;
  const [categoryBreadcrumb, setCategoryBreadcrumb] = useState(null);

  const breadcrumbSortById = breadcrumb
    .filter((item) => cateMapping.some((cate) => cate.category_id === item.id))
    .sort((a, b) => {
      return a.id - b.id;
    }).reverse();
  const cateDepth0 = breadcrumbSortById.find((item) => item.depth === 0);
  const cateDepthNotZero = breadcrumbSortById.find((item) => item.depth > 0);

  useEffect(() => {
    setCategoryBreadcrumb(true)
  }, []);

  const schemaBreadcrumb = useMemo(() => {
    if (!categoryBreadcrumb) return null;
  
    if (cateDepth0) {
      return {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Trang chủ",
            "item": "https://www.sapo.vn"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Blog",
            "item": "https://www.sapo.vn/blog"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": cateDepth0.title,
            "item": "https://www.sapo.vn/blog" + cateDepth0.alias
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": title,
            "item": "https://www.sapo.vn/blog/" + props.article.alias
          }
        ]
      };
    }
  
    const breadcrumbItems =
      cateDepthNotZero
        ? [...breadcrumb]
            .reverse()
            .map((bc, index) => ({
              "@type": "ListItem",
              "position": index + 3,
              "name": bc.title,
              "item": "https://www.sapo.vn/blog/" + bc.alias
            }))
        : [];
  
    return {
      "@context": "http://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Trang chủ",
          "item": "https://www.sapo.vn"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Blog",
          "item": "https://www.sapo.vn/blog"
        },
        ...breadcrumbItems,
        {
          "@type": "ListItem",
          "position": 2 + breadcrumbItems.length + 1,
          "name": title,
          "item": "https://www.sapo.vn/blog/" +  props.article.alias
        }
      ]
    };
  }, [categoryBreadcrumb, breadcrumb, cateDepth0, cateDepthNotZero, article]);
  

  return (
    <>
    <>{categoryBreadcrumb && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaBreadcrumb) }} />}</>
      <div className={styles["breadcrumb-article"]}>
        <ul className={styles["clearfix"]}>
          <li>
            <Link href={process.env.NEXT_PUBLIC_BASE_URL + process.env.NEXT_PUBLIC_BASE_PATH}>Blog</Link>
            <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M0.734835 0.234835C0.881282 0.0883883 1.11872 0.0883883 1.26517 0.234835L4.26517 3.23483C4.41161 3.38128 4.41161 3.61872 4.26517 3.76517L1.26517 6.76516C1.11872 6.91161 0.881282 6.91161 0.734835 6.76516C0.588388 6.61872 0.588388 6.38128 0.734835 6.23484L3.46967 3.5L0.734835 0.765165C0.588388 0.618718 0.588388 0.381282 0.734835 0.234835Z" fill="#868686" />
            </svg>
          </li>
          {cateDepth0 ? (
            <li>
              {cateDepth0?.alias?.includes("/") ? (
                <Link
                  href={`${process.env.NEXT_PUBLIC_BASE_URL + process.env.NEXT_PUBLIC_BASE_PATH}/${cateDepth0?.alias}`}
                  title={cateDepth0.title}
                >
                  {cateDepth0.title ?? "Blog"}
                </Link>
              ) : (
                <Link href={cateDepth0?.alias ? "/" + cateDepth0?.alias : "/"} title="Blog">
                  {cateDepth0?.title ?? "Blog"}
                </Link>
              )}

            </li>
          ) : null}
          {cateDepthNotZero && !cateDepth0 ? (
            <li>
              {cateDepthNotZero?.alias?.includes("/") ? (
                <Link
                  href={`${process.env.NEXT_PUBLIC_BASE_URL + process.env.NEXT_PUBLIC_BASE_PATH}/${cateDepthNotZero?.alias}`}
                  title={cateDepthNotZero.title}
                >
                  {cateDepthNotZero.title ?? "Blog"}
                </Link>
              ) : (
                <Link href={cateDepthNotZero?.alias ? "/" + cateDepthNotZero?.alias : "/"} title="Blog">
                  {cateDepthNotZero?.title ?? "Blog"}
                </Link>
              )}
            </li>
          ) : null}
        </ul>
        <h1>{title}</h1>
        <div className={classNames(styles["post-info"], "d-md-flex align-items-center")}>
          <div className={styles["time-view"]}>
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M2.78593 2.28596C4.03618 1.03572 5.73187 0.333344 7.49998 0.333344C9.26809 0.333344 10.9638 1.03572 12.214 2.28596C13.4643 3.53621 14.1666 5.2319 14.1666 7.00001C14.1666 7.87549 13.9942 8.74239 13.6592 9.55123C13.3241 10.3601 12.8331 11.095 12.214 11.7141C11.595 12.3331 10.86 12.8242 10.0512 13.1592C9.24236 13.4942 8.37546 13.6667 7.49998 13.6667C6.6245 13.6667 5.75759 13.4942 4.94876 13.1592C4.13992 12.8242 3.40499 12.3331 2.78593 11.7141C2.16688 11.095 1.67581 10.3601 1.34078 9.55123C1.00575 8.7424 0.833313 7.87549 0.833313 7.00001C0.833313 5.2319 1.53569 3.53621 2.78593 2.28596ZM7.49998 1.66668C6.08549 1.66668 4.72894 2.22858 3.72874 3.22877C2.72855 4.22897 2.16665 5.58552 2.16665 7.00001C2.16665 7.70039 2.3046 8.39392 2.57262 9.04099C2.84065 9.68806 3.2335 10.276 3.72874 10.7712C4.22399 11.2665 4.81193 11.6593 5.459 11.9274C6.10607 12.1954 6.7996 12.3333 7.49998 12.3333C8.20036 12.3333 8.89389 12.1954 9.54096 11.9274C10.188 11.6593 10.776 11.2665 11.2712 10.7712C11.7665 10.276 12.1593 9.68806 12.4273 9.04099C12.6954 8.39392 12.8333 7.70039 12.8333 7.00001C12.8333 5.58552 12.2714 4.22897 11.2712 3.22877C10.271 2.22858 8.91447 1.66668 7.49998 1.66668ZM7.49998 3.00001C7.86817 3.00001 8.16665 3.29849 8.16665 3.66668V6.72387L9.97138 8.52861C10.2317 8.78895 10.2317 9.21106 9.97138 9.47141C9.71103 9.73176 9.28892 9.73176 9.02857 9.47141L7.02857 7.47141C6.90355 7.34639 6.83331 7.17682 6.83331 7.00001V3.66668C6.83331 3.29849 7.13179 3.00001 7.49998 3.00001Z" fill="currentColor" />
            </svg>

            <span>Cập nhật lần cuối: <span>{modDate}</span></span>
          </div>
          <div className={styles["time-view"]}>
            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M1.08707 5C2.59577 7.38931 4.40169 8.5 6.5 8.5C8.59831 8.5 10.4042 7.38931 11.9129 5C10.4042 2.61069 8.59831 1.5 6.5 1.5C4.40169 1.5 2.59577 2.61069 1.08707 5ZM0.0712535 4.74275C1.7311 1.97635 3.87222 0.5 6.5 0.5C9.12778 0.5 11.2689 1.97635 12.9287 4.74275C13.0238 4.90109 13.0238 5.09891 12.9287 5.25725C11.2689 8.02365 9.12778 9.5 6.5 9.5C3.87222 9.5 1.7311 8.02365 0.0712535 5.25725C-0.0237512 5.09891 -0.0237512 4.90109 0.0712535 4.74275ZM5.20364 3.70364C5.54745 3.35982 6.01377 3.16667 6.5 3.16667C6.98623 3.16667 7.45255 3.35982 7.79636 3.70364C8.14018 4.04745 8.33333 4.51377 8.33333 5C8.33333 5.48623 8.14018 5.95255 7.79636 6.29636C7.45255 6.64018 6.98623 6.83333 6.5 6.83333C6.01377 6.83333 5.54745 6.64018 5.20364 6.29636C4.85982 5.95255 4.66667 5.48623 4.66667 5C4.66667 4.51377 4.85982 4.04745 5.20364 3.70364ZM6.5 4.16667C6.27899 4.16667 6.06703 4.25446 5.91074 4.41074C5.75446 4.56703 5.66667 4.77899 5.66667 5C5.66667 5.22101 5.75446 5.43297 5.91074 5.58926C6.06703 5.74554 6.27899 5.83333 6.5 5.83333C6.72101 5.83333 6.93298 5.74554 7.08926 5.58926C7.24554 5.43297 7.33333 5.22101 7.33333 5C7.33333 4.77899 7.24554 4.56703 7.08926 4.41074C6.93298 4.25446 6.72101 4.16667 6.5 4.16667Z" fill="#2D2D2D" />
            </svg>

            <span>Lượt xem <span>{view}</span></span>
          </div>
         
        </div>
      </div>

    </>
  );
}
